import { Link } from "react-router-dom";
import { Container } from "@components/ui/Container";
import { branches, company, navigation } from "@data/company";
import { Logo } from "../Header/Logo";
import styles from "./Footer.module.css";

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const IconFacebook = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="currentColor" aria-hidden>
    <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.3-1.5 1.6-1.5h1.7V4.6c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2.3H7.6V14h2.8v8h3.1z" />
  </svg>
);

const IconLinkedin = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="currentColor" aria-hidden>
    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v14H.22V8zm7.4 0h4.37v1.93h.06c.61-1.15 2.1-2.36 4.32-2.36 4.62 0 5.48 3.04 5.48 7v7.43h-4.56v-6.58c0-1.57-.03-3.59-2.19-3.59-2.19 0-2.53 1.71-2.53 3.48V22H7.62V8z" />
  </svg>
);

export function Footer() {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.col}>
            <Link to="/" className={styles.brand}>
              <Logo size={42} variant="light" />
              <span className={styles.brandStack}>
                <span className={styles.brandStackTitle}>{company.name}</span>
                <span className={styles.brandStackTag}>Seguros</span>
              </span>
            </Link>
            <p className={styles.tagline}>{company.description}</p>
            <div className={styles.social}>
              <a
                href={company.social.instagram}
                target="_blank"
                rel="noopener"
                className={styles.socialLink}
                aria-label="Instagram"
              >
                <IconInstagram />
              </a>
              <a
                href={company.social.facebook}
                target="_blank"
                rel="noopener"
                className={styles.socialLink}
                aria-label="Facebook"
              >
                <IconFacebook />
              </a>
              <a
                href={company.social.linkedin}
                target="_blank"
                rel="noopener"
                className={styles.socialLink}
                aria-label="LinkedIn"
              >
                <IconLinkedin />
              </a>
            </div>
          </div>

          <div className={styles.col}>
            <h4 className={styles.heading}>Navegación</h4>
            {navigation.map((item) => (
              <Link key={item.to} to={item.to} className={styles.link}>
                {item.label}
              </Link>
            ))}
          </div>

          <div className={styles.col}>
            <h4 className={styles.heading}>Contacto</h4>
            <a className={styles.link} href={`tel:${company.phone.replace(/\s/g, "")}`}>
              {company.phone}
            </a>
            <a className={styles.link} href={`tel:${company.phoneAlt.replace(/\s/g, "")}`}>
              {company.phoneAlt}
            </a>
            <a className={styles.link} href={`mailto:${company.email}`}>
              {company.email}
            </a>
            <span className={styles.link} style={{ color: "var(--color-neutral-400)" }}>
              {company.hours}
            </span>
          </div>

          <div className={styles.col}>
            <h4 className={styles.heading}>Sucursales</h4>
            {branches.map((branch) => (
              <div key={branch.name} className={styles.branchWrap}>
                <a
                  className={styles.branch}
                  href={branch.mapUrl}
                  target="_blank"
                  rel="noopener"
                >
                  <strong>{branch.name}</strong>
                  <span>{branch.address}</span>
                  <span>{branch.city}</span>
                  {branch.phone && <span>Tel. {branch.phone}</span>}
                </a>
                {branch.hours && (
                  <div className={styles.branchHours}>
                    <span>Lun a vie: {branch.hours.weekdays}</span>
                    {branch.hours.saturday && (
                      <span>Sábados: {branch.hours.saturday}</span>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <a
          className={styles.powered}
          href="https://www.meridian-software.com"
          target="_blank"
          rel="noopener"
          aria-label="Powered by Meridian Software"
        >
          <span className={styles.poweredLabel}>Powered by</span>
          <img
            src="/meridian-software.png"
            alt="Meridian Software"
            className={styles.poweredLogo}
            width={220}
            height={64}
            loading="lazy"
          />
        </a>

        <div className={styles.bottom}>
          <span>© {new Date().getFullYear()} {company.name}. Todos los derechos reservados.</span>
          <span>Sitio en cumplimiento normativo SSN.</span>
        </div>
      </Container>
    </footer>
  );
}
